import { render, staticRenderFns } from "./FactorItemEdit.vue?vue&type=template&id=422a6357&"
import script from "./FactorItemEdit.vue?vue&type=script&lang=js&"
export * from "./FactorItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports